import { TBookCoworkingFormState } from 'shared/components/BookCoworkingFrom';
import { IBookCoworkingRequest } from 'shared/repositories/coworking/v1/book-coworking';

export const normalizeBookCoworkingRequestParams = (
  id: number,
  bookCoworkingForm: TBookCoworkingFormState,
): IBookCoworkingRequest => {
  const rentDuration = Number(bookCoworkingForm.rentDuration.value);
  const workplaceCount = Number(bookCoworkingForm.workplaceCount.value);
  const rentStartDate = bookCoworkingForm.rentStartDate.value?.toUTCString() || '';

  return {
    coworkingId: id,
    name: bookCoworkingForm.name.value,
    isBroker: bookCoworkingForm.isBroker.value,
    coworkingOfferType: bookCoworkingForm.coworkingOfferType.value,
    workplaceCount,
    rentDuration,
    rentDurationUnit: bookCoworkingForm.rentDurationUnit.value,
    rentStartDate,
    phone: bookCoworkingForm.phone.value,
  };
};
